



<h1>
  Mission
</h1>
<h2>
  Education, Elevated
</h2>
<p>Our mission is to elevate learners' experience and alleviate instructors of their most banal burden; grading. </p>
<p>
  A True STEM education is not obtained through watching lectures, selecting the circle,
  or typing an answer into a rectangle.  STEM-ability is attained through
  attempting challenging problems, suffering the inevitable corrections, and readjusting ones reasoning from the fractures
  exposed by said corrections.</p>

  <p> Everyone errs but true intelligence entails the ability to correct
  one's reasoning.
</p>


<p>To this end we've built the first autonomous evaluation system that accepts handwritten work.</p>

<p>While our system does not provide step-by-step solutions to unsolved problems, it does provide feedback to your solutions.</p>
<p>This is because we know first-hand that one must try, and maybe fail, to truly learn.</p>

<!--
<h2>
  Calculus for the World!
</h2>

<section>
<p>
  Calculus is the cornerstone of engineering and an appropriate introduction to the beauty and divinity
  of Math as it is traditionally the first Maths class in which students are exposed to unsolvable problems.

</p>
<div class="outer-list">
<ul class="no-bullets">

  <li>
    necessary for all engineering directly involving physical components.
  </li>
  <li>
     the first applied math field in which one organically encounters unsolvable problems.
  </li>

  <li>
     the foundation upon which a vast deal of physics becomes tractable or at minimum comprehensible.
  </li>

</ul>
</div>
<p>Furthermore we believe that the dichotomy of those who enjoy math and do not is laid bear by those who have
  had good Calculus instruction and those who have not.
</p>

</section>
-->
<!--

<section>

<p>
  The benefits of a STEMducation exceed the immediate rush of getting a 5 on your AP exam or an A in your course.
  STEM helps one enhance their general analytical abilities in a way that will likely be unparalleled until the advent of
  the brain computer interface.
</p>

<p>
  Unfortunately the process of STEMducation does not scale well with number of students, difficulty of problems, or quality of
  feedback. Our solution offers robust feedback, equivalent to that provided by a diligent instructor.
</p>
<p>
Evalugrade is the only autonomous grading solution
  </p>
<div class="outer-list">
<ul class="no-bullets">

  <li>
    accepting handwritten input
  </li>
  <li>
    capable of exposing exact location(s) of errors
  </li>
  <li>
    providing instant detailed feedback

  </li>
</ul>
</div></section>


<section>
  <p>
  We know that STEMducation has not been disseminated equitably. While in some cases technology has been the source of,
    or assisted in, a great deal of inequity, we believe that the innovations of the internet era have the potential to
    unbind more than shackle. <a href="https://datareportal.com/global-digital-overview" >Most of the world now has
    internet access </a> meaning that most of the world has access to the majority of information.
    Unfortunately to all but the most savy users this results in a limitless supply of
    plausible sounding non-sense. We seek to provide an unbounded solution to the most poorly scaling component of
    education; grading.

</p>
</section>


<style>
  a:link{
    color: red;
    text-decoration: none;
  }
  a{
    color:white
  }
  a:active{
    color: red;
    text-decoration: none;
  }

  ul.no-bullets {
      list-style-type: none;
    list-style: inside;
      /*text-align: center;*/
  }
  .outer-list{
    margin:auto;
    display: table;
    position: center;
  }
  section{
    min-height: 13vh;
  }
  p{
   text-align: left;
  }
/*
  li{
    display:inline-block;
  }*/
</style>
-->
<!--is beyond glorified form validation.-->
<!--is beyond glorified form validation.-->